export enum TEMPLATE_STATE {
  DISABLE,
  ENABLE,
  RESERVATION
}
